{
  "name": "rouse-sales-catalog",
  "version": "2.54.0",
  "scripts": {
    "build": "npm run build:app",
    "build:app": "ng build --output-hashing=all",
    "build:docs": "swagger-combine docs/api.yaml -o docs/api_public.yaml",
    "build:storybook": "npm run docs:json && build-storybook",
    "update:runtime": "node update-runtime.js",
    "lint": "ng lint",
    "ng": "ng",
    "test": "echo \"Karma test runner removed. E2E tests are configured in playwright/.\" && exit 0",
    "start": "ng serve --proxy-config proxy.conf.json",
    "docs:json": "compodoc -p ./tsconfig.json -e json -d .",
    "docs:api": " node docs/api.js",
    "storybook": "npm run docs:json && start-storybook -p 6006",
    "build-storybook": "npm run docs:json && build-storybook",
    "analyze:bundle": "ng build --stats-json &git& webpack-bundle-analyzer dist/rouse-catalog/stats.json"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/architect": "^0.2202.0",
    "@angular-slider/ngx-slider": "^22.0.0",
    "@angular/animations": "^22.2.0",
    "@angular/cdk": "^22.2.0",
    "@angular/common": "^22.2.0",
    "@angular/compiler": "^22.2.0",
    "@angular/core": "^22.2.0",
    "@angular/fire": "^20.1.0",
    "@angular/forms": "^22.2.0",
    "@angular/material": "^22.2.0",
    "@angular/platform-browser": "^22.2.0",
    "@angular/platform-browser-dynamic": "^22.2.0",
    "@angular/router": "^22.2.0",
    "@auth0/angular-jwt": "^5.0.2",
    "@auth0/auth0-angular": "^2.2.3",
    "@fortawesome/angular-fontawesome": "^0.10.2",
    "@fortawesome/fontawesome-svg-core": "^1.2.35",
    "@fortawesome/free-brands-svg-icons": "^5.9.0",
    "@fortawesome/free-regular-svg-icons": "^5.15.3",
    "@fortawesome/free-solid-svg-icons": "^5.15.3",
    "@ngx-loading-bar/core": "^7.0.1",
    "@ngx-loading-bar/http-client": "^7.0.1",
    "@ngx-loading-bar/router": "^7.0.1",
    "@sentry/angular": "^10.42.0",
    "@sentry/tracing": "^7.3.0",
    "@types/css-font-loading-module": "^0.0.7",
    "core-js": "^3.50.0",
    "css-loader": "^6.7.3",
    "dompurify": "^3.4.16",
    "dotenv": "^17.4.2",
    "firebase": "^11.4.0",
    "fs": "0.0.1-security",
    "lodash-es": "^4.18.1",
    "process": "^0.11.10",
    "retry-axios": "^2.6.0",
    "rxjs": "^7.8.1",
    "style-loader": "^3.3.2",
    "tslib": "^2.0.0",
    "util": "^0.12.5",
    "zone.js": "^0.16.3"
  },
  "overrides": {
    "engine.io": {
      "ws": "^8.21.0"
    },
    "socket.io-adapter": {
      "ws": "^8.21.0"
    },
    "@angular/cli": {
      "@modelcontextprotocol/sdk": "1.30.0"
    },
    "@hono/node-server": "2.0.12",
    "@angular/fire": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core",
      "@angular/platform-browser": "$@angular/platform-browser",
      "@angular/platform-browser-dynamic": "$@angular/platform-browser-dynamic"
    },
    "@tootallnate/once": "^3.0.1",
    "undici": "^7.30.0",
    "vite": "7.3.6",
    "protobufjs": "^7.6.5",
    "uuid": ">=11.1.1",
    "picomatch": "4.0.4",
    "anymatch": {
      "picomatch": "2.3.2"
    },
    "micromatch": {
      "picomatch": "2.3.2"
    },
    "compodoc": {
      "picomatch": "2.3.2"
    },
    "readdirp": {
      "picomatch": "2.3.2"
    },
    "minimatch@3.1.5": {
      "brace-expansion": "1.1.21"
    },
    "minimatch@9.0.7": {
      "brace-expansion": "5.0.12"
    },
    "minimatch@10.2.4": {
      "brace-expansion": "5.0.12"
    },
    "minimatch@10.2.5": {
      "brace-expansion": "5.0.12"
    },
    "nanoid": "3.3.18",
    "qs": ">=6.16.0",
    "@grpc/grpc-js": "1.14.5"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.5.0",
    "@angular-eslint/eslint-plugin": "^22.5.0",
    "@angular-eslint/eslint-plugin-template": "^22.5.0",
    "@angular-eslint/template-parser": "^22.1.0",
    "@angular/build": "^22.2.0",
    "@angular/cli": "^22.2.0",
    "@angular/compiler-cli": "^22.2.0",
    "@angular/language-service": "^22.2.0",
    "@babel/core": "^7.29.6",
    "@babel/preset-env": "^7.21.4",
    "@babel/register": "^7.18.6",
    "@compodoc/compodoc": "^2.0.0",
    "@google-cloud/secret-manager": "^5.6.0",
    "@playwright/test": "^1.56.1",
    "@stylistic/eslint-plugin": "^2.3.0",
    "@stylistic/eslint-plugin-ts": "^2.3.0",
    "@types/dompurify": "^3.0.2",
    "@types/lodash-es": "^4.17.6",
    "@types/node": "^12.11.1",
    "@typescript-eslint/eslint-plugin": "^8.37.0",
    "@typescript-eslint/parser": "^8.37.0",
    "acorn": "^8.1.0",
    "angular-http-server": "^1.9.0",
    "axios": "^1.20.0",
    "babel-loader": "^10.1.1",
    "chai": "^4.2.0",
    "es5-ext": "^0.10.64",
    "eslint": "^9.39.2",
    "eslint-config-prettier": "^7.2.0",
    "eslint-plugin-import": "^2.22.1",
    "eslint-plugin-jsdoc": "latest",
    "eslint-plugin-prefer-arrow": "latest",
    "eslint-plugin-prettier": "^3.3.1",
    "form-data": "^4.0.6",
    "glob": "^7.1.6",
    "husky": "^9.1.7",
    "moment": "^2.31.0",
    "moment-timezone": "^0.5.32",
    "playwright-qase-reporter": "^2.5.7",
    "prettier": "^2.2.1",
    "sass": "^1.62.1",
    "sass-loader": "^13.2.2",
    "swiper": "^12.1.2",
    "ts-node": "^10.9.1",
    "typescript": "~6.0.0",
    "webpack": "^5.94.0",
    "webpack-bundle-analyzer": "^4.9.1",
    "yamljs": "^0.3.0",
    "yargs": "^15.3.1"
  }
}
